import { Box, styled } from "@mui/material";
import { StyledComponentProps } from "../../models/global/Types";

export const StyledCalandar = styled(Box)(
  ({ theme }: StyledComponentProps) => ({
    width: "90%",
    height: "80%",
    border: `2px solid ${theme.color.dark}`,
    margin: "auto",
    borderRadius: "25px",
  })
);
